<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center text-muted mb-4">
                            <img src="https://vremec.com.mx/assets/img/brand/vremec-logo.png" class="navbar-brand-img" alt="Logo VREMEC">
                        </div>
                        <div class="text-center">
                            <h1>
                            VREMEC
                            </h1>
                        </div>
                        <div class="text-center">
                            <base-button type="primary" @click="auth0Login()" class="my-4">Iniciar sesión</base-button>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 text-right">
                        <a class="text-light"><small>© VREMEC 2020</small></a>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import store from '../store'
export default {
    name: 'login',
    data() {
      return {
        model: {
          email: '',
          password: ''
        }
      }
    },
    methods: {
        auth0Login: () => {
            store.dispatch('auth0Login', true)
        }
    }
}
</script>
<style>
</style>
